// extracted by mini-css-extract-plugin
export var bfcmContentCard = "bfcmContentCard-module--bfcmContentCard--28ea6";
export var button = "bfcmContentCard-module--button--a1e0e";
export var buttonContainer = "bfcmContentCard-module--buttonContainer--23b12";
export var contentContainer = "bfcmContentCard-module--contentContainer--15526";
export var cursorDefault = "bfcmContentCard-module--cursorDefault--cdb92";
export var cursorPointer = "bfcmContentCard-module--cursorPointer--0035b";
export var desktopImage = "bfcmContentCard-module--desktopImage--ed125";
export var eyebrowContainer = "bfcmContentCard-module--eyebrowContainer--fc72f";
export var headline = "bfcmContentCard-module--headline--bc90c";
export var image = "bfcmContentCard-module--image--94d9f";
export var imageContainer = "bfcmContentCard-module--imageContainer--3d4d7";
export var imageLink = "bfcmContentCard-module--imageLink--8b3e1";
export var mobileImage = "bfcmContentCard-module--mobileImage--6d1f1";
export var subheadline = "bfcmContentCard-module--subheadline--71f2d";
export var video = "bfcmContentCard-module--video--67244";
export var videoImageContainer = "bfcmContentCard-module--videoImageContainer--1b7d9";